/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class SpinnerPositionTypes {
    static DEFAULT = '';

    static SPINNER_POSITION_TOP = 'top';
}
